import "./ImplantTreatment.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import PrivateEquitySolutions from "./sections/PrivateEquitySolutions";
import HowItWorks from "./sections/HowItWorks";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function ImplantTreatmentPage() {
  return <div>
      <Header />
      <Hero />
      <PrivateEquitySolutions />
      <HowItWorks />
      <Projects />
      <Footer />
    </div>;
}